import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { Store, select } from '@ngrx/store';
import { Animals } from 'src/app/modules/acbcr/common/models/animal.models';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getAppHoldingsNames } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { HoldingsNames } from 'src/app/modules/acbcr/common/models/holdings.models';
import { Subject } from 'rxjs';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';

@Component({
  selector: 'app-animal',
  templateUrl: './animal.component.html',
  providers: [AnimalsTableService, DecimalPipe]
})
export class AnimalComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  animalData: Animals;
  addEditModalData;
  solicitareTestADNModalData;
  fisaBonitareModalData;

  loadingDataSpinner = false;
  AnimalId: any;

  defaultAnimalImage;
  otherAnimalImages = [];

  insamantareTypes = [
    { id: 0, name: 'Nespecificat' },
    { id: 1, name: 'Însămânțare artificială' },
    { id: 2, name: 'Montă naturală autorizată' },
    { id: 3, name: 'Embriotransferuri' }
  ];
  insamantareLabel: string;

  colorsType = [
    { id: 0, name: 'Alb' },
    { id: 1, name: 'Roșu' },
    { id: 2, name: 'Negru' }
  ];
  colorLabel: string;

  femeleCategory = [
    { id: 0, name: 'Nespecificat' },
    { id: 1, name: 'Vițea' },
    { id: 2, name: 'Primipară' },
    { id: 3, name: 'Multipară' },
    { id: 4, name: 'Junincă' },
  ];
  femeleCategoryLabel: string;

  holdingsNames;
  ownerLabel: string;
  codExploatatie: string;
  isAdmin = false;
  isOperator = false;
  isFermier = false;
  isAutoritateJudeteana = false;
  isContabil = false;
  currentRoute = '';


  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private helperDataService: HelperDataService,
    private animalsTableService: AnimalsTableService,
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
  ) { }

  ngOnInit(): void {
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
    this.isFermier = UIHelper.isFermier();

    this.route.params
      .pipe(distinctUntilChanged((prev, curr) => prev['id'] === curr['id']))
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.AnimalId = params['id'];
        this._processServerData();
      });
  }

  get previousRoute() { return localStorage['previous-route'] }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  openEditAnimalModal(type: string) {
    this.animalsTableService
      .getAnimalAPI(Number(this.route.snapshot.paramMap.get('id')))
      .subscribe(response => {
        this.animalData = response;
        this.addEditModalData = {
          animalData: response,
          modalType: type,
        };
      });
  }

  closeAddEditModal() {
    this._processServerData();
  }

  generateFisaAnimal(animalId) {
    let fileName = `Fisa_animal_${this.animalData.numarmatricol}.pdf`;

    this.animalsTableService.generateFisaAnimal(animalId)
      .subscribe((response: any) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        this.helperDataService.simulateDownload(blob, fileName);
      });
  }

  descarcaIstoric(animalId) {
    this.loadingDataSpinner = true;
    this.animalsTableService.downloadAnimalHistoryApi(animalId)
      .subscribe((response: any) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        this.helperDataService.simulateDownload(blob, this.animalData.numarmatricol + `_istoric.xls`);
        setTimeout(() => {
          this.loadingDataSpinner = false;
        }, 500);
      });
  }

  clickSolicitareTestADN(animalId) {
    this.solicitareTestADNModalData = {
      animal_id: animalId,
    }
  }

  clickFisaBonitare(animalData) {
    this.fisaBonitareModalData = {
      animal_id: animalData.id,
      numarmatricol: animalData.numarmatricol,
    }
  }

  _processServerData() {
    this.animalsTableService
      .getAnimalAPI(this.AnimalId)
      .subscribe(response => {
        this.animalData = response;

        let defaultImage = null;
        let otherImages = [];
        this.defaultAnimalImage = null;
        this.otherAnimalImages = [];
        let poze = this.animalData['poze'] || [];

        poze.map(img => {
          if (img['filetype'] === 'default') {
            defaultImage = img['fileid'];
          } else {
            otherImages.push(img['fileid']);
          }
        });

        if (defaultImage) {
          this.animalsTableService.getPozaUrl(defaultImage).subscribe(image => {
            this.defaultAnimalImage = image?.url;
          });
        }

        otherImages.map(other => {
          this.animalsTableService.getPozaUrl(other).subscribe(otherImg => {
            this.otherAnimalImages.push(otherImg?.url);
          });
        });


        this.insamantareTypes.map(type => {
          if ((type.id === this.animalData.sistemreproductie)) {
            this.insamantareLabel = type.name;
          }
        });

        this.colorsType.map(color => {
          if (color.id === this.animalData.color) {
            this.colorLabel = color.name;
          }
        });

        this.femeleCategory.map(category => {
          if (category.id === this.animalData.categoriefemela) {
            this.femeleCategoryLabel = category.name;
          }
        });

        this.store.pipe(select(getAppHoldingsNames))
          .pipe(takeUntil(this.destroy$))
          .subscribe((holdings: HoldingsNames[]) => {
            this.holdingsNames = holdings;
            this.holdingsNames.map(holding => {
              if (holding.id === this.animalData.exploatatieid) {
                this.ownerLabel = holding.name;
                this.codExploatatie = holding.code;
              }
            });
          });
      });
  }

}
